import { connect } from 'react-redux'
import DesktopLinks from 'components/layout/DesktopLinks'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  isLogged: state.user.isLogged,
  isExternalAuth: state.user.details.isExternalAuth
})

export default connect(mapStateToProps, null)(DesktopLinks)
